<template>
  <div class="principal-input-fecha">
    <v-menu
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :disabled="deshabilitado"
          @click="ReestablecerRegla()"
          v-model="formatoFecha"
          ref="valorFechaTexto"
          readonly
          v-bind="attrs"
          v-on="on"
          @click:append="on.click"
          append-icon="far fa-calendar-alt"
          solo
          :placeholder="idioma == 'es-MX' ? 'DD/MM/YYYY' : 'YYYY/MM/DD'"
          height="45px"
          clearable
        >
        </v-text-field>
      </template>
      <v-date-picker
        v-model="valorInterno"
        @change="ObtenerValor($event)"
        @input="menu2 = false"
        ref="valorFecha"
        color="#b8725a"
        :locale="idioma"
        :max="fechaMaxima"
        :min="fechaMinima"
        next-icon="fas fa-chevron-right"
        prev-icon="fas fa-chevron-left"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "InputFecha",
  props: {
    deshabilitado: Boolean,
    idioma: String,
    value: String,
    fechaMinima: {
      type: String,
      default: null
    },
    fechaMaxima: {
      type: String,
      default: null
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val !== null) {
          this.valorInterno = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    ObtenerValor(evento) {
      this.$emit("input", evento);
      this.cerrarSelector = true;
    },
    ReestablecerRegla() {
      this.cerrarSelector = false;
    }
  },
  computed: {
    formatoFecha() {
      if (this.valorInterno != "") {
        let fechaFormateada;
        if (this.idioma == "es-MX") {
          fechaFormateada =
            this.valorInterno.substring(8, 10) +
            "-" +
            this.valorInterno.substring(5, 7) +
            "-" +
            this.valorInterno.substring(0, 4);
          return fechaFormateada;
        } else {
          fechaFormateada = this.valorInterno;
          return fechaFormateada;
        }
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      menu2: false,
      valorInterno: "",
      rules: {
        required: value => !!value || "required"
      }
    };
  }
};
</script>

<style scoped></style>
